import { Work } from '@/model/master-data/Work'

export class QcqShiftCompetences {
  public constructor (
    public shiftId: number | undefined,
    public planningGroupId: number | undefined,
    public id: number | undefined,
    public competences: number | null,
    public competencesDescription: string,
    public educationLevelId: number | null,
    public educationLevelDescription: string,
    public jobId: number | null,
    public jobDescription: string,
    public specializationId: number | null,
    public specializationDescription: string,
    public detailsId: number | null,
    public detailsDescription: string,
    public comment: string,
    public departments: number | undefined,
    public planningGroup: number | undefined,
    public work: number,
    public workCode: string,
    public offset: string,
    public workItem: Work | undefined,
    public quality: number | null
  ) {}

  get displayLabel (): string {
    if(this.workItem) {
      return `${this.workItem.code} - ${this.workItem.getDescriptionLabel}`
    } else {
      return this.workCode
    }
  }
}